<template>
  <scroll-picker
    :confirmTxt="confirmTxt"
    :cancelTxt="cancelTxt"
    ref="picker"
    :data="pickerData"
    :selectedIndex="selectedIndex"
    @change="change"
    @select="select"
  />
</template>

<script>
import ScrollPicker from '../ScrollPicker/ScrollPicker';
import areaData from './area';

export default _extend({
  name: 'DistrictPicker',
  data() {
    return {
      pickerData: [[], [], []],
      selectedIndex: [0, 0, 0]
    };
  },
  computed: {
    newAreaData() {
      let firstIndex = 0;
      let data = [...areaData];
      data.forEach((item, index) => {
        if (item.validator(this.language)) {
          firstIndex = index;
        }
      });
      let newData = [];
      [...data.splice(firstIndex, 1), ...data].forEach(item => {
        newData = newData.concat(item.data);
      });
      return newData;
    }
  },
  components: {
    ScrollPicker
  },
  props: {
    confirmTxt: {
      type: String,
      default: ''
    },
    cancelTxt: {
      type: String,
      default: ''
    },
    language: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: []
    }
  },
  methods: {
    show() {
      this.initial();
      this.$refs.picker.show();
    },
    initial() {
      let firstIndex = this.newAreaData.findIndex(item => {
        return item.n === this.value[0];
      });
      let secondIndex = -1;
      let thirdIndex = -1;
      if (firstIndex > -1) {
        secondIndex = this.newAreaData[firstIndex].s.findIndex(item => {
          return item.n === this.value[1];
        });
      }
      if (secondIndex > -1) {
        thirdIndex = this.newAreaData[firstIndex].s[secondIndex].c.findIndex(item => {
          return item === this.value[2];
        });
      }
      let selectedIndex = [firstIndex > -1 ? firstIndex : 0, secondIndex > -1 ? secondIndex : 0, thirdIndex > -1 ? thirdIndex : 0];
      this.pickerData = this.getData(selectedIndex[0], selectedIndex[1]);
      this.selectedIndex = selectedIndex;
    },
    getData(firstIndex, secondIndex) {
      let firstData = [];
      this.newAreaData.forEach(item => {
        firstData.push({
          value: item.n,
          text: item.n
        });
      });
      let secondData = this.newAreaData[firstIndex].s.map(item => {
        return {
          value: item.n,
          text: item.n
        };
      });
      let thirdData = this.newAreaData[firstIndex].s[secondIndex].c.map(item => {
        return {
          value: item,
          text: item
        };
      });
      return [firstData, secondData, thirdData];
    },
    change(index, dist) {
      if (index === 0) {
        this.pickerData = this.getData(dist, 0);
        this.selectedIndex = [dist, 0, 0];
      } else if (index === 1) {
        this.pickerData = this.getData(this.selectedIndex[0], dist);
        this.selectedIndex = [this.selectedIndex[0], dist, 0];
      } else {
        this.selectedIndex = [this.selectedIndex[0], this.selectedIndex[1], dist];
      }
      this.$refs.picker.refill(this.pickerData);
    },
    select(...args) {
      this.pickerData = this.getData(args[1][0], args[1][1]);
      this.selectedIndex = args[1];
      this.$refs.picker.refill(this.pickerData);
      this.$emit('select', args[2]);
    }
  },
  watch: {
    value () {
      this.initial();
    }
  }
});
</script>



// WEBPACK FOOTER //
// src/components/DistrictPicker/DistrictPicker.vue